import { render, staticRenderFns } from "./MFolderItem.vue?vue&type=template&id=2536066c&scoped=true&"
import script from "./MFolderItem.vue?vue&type=script&setup=true&lang=ts&"
export * from "./MFolderItem.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./MFolderItem.vue?vue&type=style&index=0&id=2536066c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2536066c",
  null
  
)

export default component.exports